import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Container } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export const Forbidden = () => (
  <Container className="text-center">
    <Row>
      <Col className="text-center">
        <p>
          <FontAwesomeIcon icon={faExclamationTriangle} size="5x" color="gray"/>
          <br/><br/>Status Code: 403
        </p>
      </Col>
    </Row>
    <Row>
      <Col>
        <h3>OPPSSS!!!! Sorry...</h3>
        <p>Sorry, your access is refused due to security reasons of our server and also our sensitive data.<br/>Please
          go back to the previous page to continue browsing.</p>
        <Button variant="danger" onClick={() => window.history.back()}>Go Back</Button>
      </Col>
    </Row>
  </Container>
);

export default Forbidden;